export default __webpack_public_path__ + "static/media/download-button.13eaec84.png";